import { inarixColors } from "inarix-theme";

export const DataTableFiltersStyles = {
  DataFiltersSideBarButton: {
    textTransform: "none",
    background: inarixColors.contrast_inarix,
    color: inarixColors.main_inarix,
    fontWeight: 500,
    borderColor: "#C0C0C0",
    "&:hover": {
      backgroundColor: inarixColors.action_hover_inarix,
      border: `solid 0.5px #000`,
      boxShadow: "none",
    },
  },

  FiltersIcon: {
    marginRight: "5px",
    fontWeight: 500,
  },

  FiltersIconDiv: {
    fontWeight: 600,
    fontSize: "13px",
  },

  SideBar: {
    Box: {
      display: "flex",
    },
    Button: {
      width: "100%",
      textTransform: "none",
    },
    Drawer: {
      width: 420,
      flexShrink: 0,
      "& .MuiDrawer-paper": {
        width: 420,
        boxSizing: "border-box",
        position: "absolute",
        zIndex: 1,
        overflow: "auto",
        overflowX: "hidden",
      },
    },
  },

  SpeciesFilter: {
    width: "100%",
    maxWidth: 360,
    bgcolor: "background.paper",
    height: 200,
    overflow: "auto",
  },
};
